<template>
  <div class="operation-list-pagination">
    <div class="flex justify-end items-center mt-5">
      <div class="mr-5">
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer"
          :color="AISEA_COLOR.BLUE"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2 aisea-text-12-400-black"
              >{{ displayElementFrom }}
              -
              {{ displayElementTo }}
              / {{ totalElement }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="option in pageSizeOptions"
              :key="option"
              @click="onChangePageSize(option)"
              :color="AISEA_COLOR.BLUE"
            >
              <span class="aisea-text">{{ option }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <div>
        <vs-pagination
          :total="totalPages"
          :max="7"
          v-model="displayCurrentPage"
          :color="AISEA_COLOR.BLUE"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
export default {
  name: "OperationListPagination",
  mixins: [ColorMixin],
  props: {
    currentPage: {
      type: Number,
      required: true,
      default: 0,
    },
    pageSize: {
      type: Number,
      required: true,
      default: 0,
    },
    totalElement: {
      type: Number,
      required: true,
      default: 0,
    },
    pageSizeOptions: {
      type: Array,
      required: false,
      default: () => {
        return [25, 50, 75, 100];
      },
    },
  },
  data() {
    return {
      displayCurrentPage: this.currentPage,
    };
  },
  watch: {
    currentPage(value) {
      this.displayCurrentPage = value;
    },
    displayCurrentPage(value) {
      this.onChangePage(value);
    },
  },
  computed: {
    totalPages() {
      if (this.totalElement == 0) return 0;
      return Math.ceil(this.totalElement / this.pageSize);
    },
    displayElementFrom() {
      if (this.totalElement == 0) return 0;
      return this.currentPage * this.pageSize - (this.pageSize - 1);
    },
    displayElementTo() {
      if (this.totalElement - this.currentPage * this.pageSize > 0)
        return this.currentPage * this.pageSize;
      else return this.totalElement;
    },
  },
  methods: {
    onChangePageSize(pageSize) {
      this.$emit("onChangePageSize", pageSize);
    },
    onChangePage(page) {
      this.$emit("onChangePage", page);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
.operation-list-pagination {
  .aisea-text {
    font-family: $aisea-font-family;
  }
}
</style>
